import { h$1 as u, me as b, h as a, Y as v, m, o as h } from "../chunks/register-Ba9sFUKZ.js";
import * as p from "react";
const l = {
  beaconTagName: "beacon-tab-panel"
}, f = u`:host([aria-hidden=true]){display:none}:host(:focus-visible){box-shadow:0 0 0 var(--beacon-system-width-border-jumbo) var(--beacon-system-color-border-focus-middle),0 0 0 var(--beacon-system-width-border-maxi) var(--beacon-system-color-border-focus-outer);outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-inner);outline-offset:0;position:relative;z-index:1}`;
var y = Object.defineProperty, r = (n, t, d, B) => {
  for (var o = void 0, c = n.length - 1, i; c >= 0; c--)
    (i = n[c]) && (o = i(t, d, o) || o);
  return o && y(t, d, o), o;
};
const s = class extends b {
  constructor() {
    super(...arguments), this.beaconTagName = l.beaconTagName, this.ariaHidden = "true", this.role = "tabpanel", this.tabIndex = -1;
  }
  static get styles() {
    return [super.styles, f];
  }
  /**
   * Sets tabindex based on ariaHidden property
   * @param changedProperties an Inherited Map of properties that have changed since the last update.
   */
  willUpdate(t) {
    t && t.has("ariaHidden") && (this.tabIndex = this.ariaHidden === "true" ? -1 : 0);
  }
  render() {
    return v`<slot></slot>`;
  }
};
s.shadowRootOptions = {
  ...b.shadowRootOptions,
  delegatesFocus: !1
}, s.tagName = l.beaconTagName;
let e = s;
r([
  a({ reflect: !0 })
], e.prototype, "value");
r([
  a({ reflect: !0, attribute: "aria-hidden" })
], e.prototype, "ariaHidden");
r([
  a({ reflect: !0 })
], e.prototype, "role");
r([
  a({ reflect: !0, attribute: "tabindex" })
], e.prototype, "tabIndex");
const w = (n) => (m(n, e), h({
  tagName: n ? n + "-" + e.tagName : e.tagName,
  elementClass: e,
  react: p,
  events: {
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  w as default,
  w as reactBeaconTabPanel
};
